import type {
    CycleCommunicationMilestoneTypeValue,
    CycleCommunicationRecipientTypeValue,
} from '@/constants/cycle-evaluation/CycleCommunication';
import type {
    CycleAudienceTypeValue,
    CycleEvaluationStatusValue,
    EvaluationTypeValue,
} from '@/constants/cycle-evaluation/CycleEvaluation';
import type { CycleEvaluationGroupStepsType } from '@/constants/cycle-evaluation/CycleEvaluationGroupSteps';
import type { FrequencyValue } from '@/constants/Frequency';
import type { CycleAudienceCriteriaFields } from '@/types/cycle-evaluation/CycleAudience';
import type { CycleLaunchSnapshot } from '@/types/cycle-evaluation/CycleLaunchSnapshot';

export const CycleEvaluationGroupStatus = {
    DRAFT: 'Draft',
    ACTIVE: 'Active',
    DEACTIVATED: 'Deactivated',
    COMPLETED: 'Completed',
} as const;

export type CycleEvaluationGroupStatusValue =
    (typeof CycleEvaluationGroupStatus)[keyof typeof CycleEvaluationGroupStatus];

export interface CycleEvaluationGroupChild {
    id: string;
    reviewType: EvaluationTypeValue;
    status?: CycleEvaluationStatusValue;
}

export interface CycleCommunicationEmail {
    id: string;
    recipient: CycleCommunicationRecipientTypeValue;
    title: Record<string, string>;
    body: Record<string, string>;
    isEnabled: boolean;
}

export interface CycleCommunicationBlock {
    id: string;
    milestoneType: CycleCommunicationMilestoneTypeValue;
    isEnabled: boolean;
    emails: CycleCommunicationEmail[];
}

export type CycleEvaluationGroupAudienceCriteria = CycleAudienceCriteriaFields & { id: string };

export interface CycleEvaluationGroupAudience {
    id: string;
    cycleAudienceType: CycleAudienceTypeValue;
    cycleAudienceCriterias: CycleEvaluationGroupAudienceCriteria[];
}

export interface CycleEvaluationGroup {
    id: string;
    name: string;
    evaluationPeriodId?: string;
    evaluationPeriodStart?: string;
    evaluationPeriodEnd?: string;
    status: CycleEvaluationGroupStatusValue;
    currentStep: CycleEvaluationGroupStepsType;
    cycleEvaluations: CycleEvaluationGroupChild[];
    dormantCycleEvaluations?: CycleEvaluationGroupChild[];
    frequency?: FrequencyValue | null;
    audience?: CycleEvaluationGroupAudience | null;
    skippedMilestonesCount?: number | null;
    skippedRemindersCount?: number | null;
    deletedCycleEvaluationsCount?: number | null;
    deletedGeneratedEvaluationsCount?: number | null;
    communications?: CycleCommunicationBlock[];
    launchedConfiguration?: CycleLaunchSnapshot | null;
}
